import _ from 'lodash';
import productUtils from "@/utils/portaus-utils";

const marginFormatted = (state) => index =>{
  return state.purchaseOrder.lines[index].margin;
}

const totalWithMargin = (state) => index =>{
  return state.purchaseOrder.lines[index].purchase_unit_price+state.purchaseOrder.lines[index].margin;
}

const unitFormatted = (state) => index => {
  return productUtils.getFormattedUnit_i18n(state.purchaseOrder.lines[index].product.unit);
}

const subTotal = (state) =>{
  let subtotal =0;
  _.forEach(state.purchaseOrder.lines, line=>{
    subtotal+=line.total;
  })
  return parseFloat(subtotal.toFixed(2));
}

const total = (state) =>{
  let total = 0;
  _.forEach(state.purchaseOrder.lines, line=>{
    total+=line.total;
  })
  total+=state.purchaseOrder.adjustment;
  return parseFloat(total.toFixed(2));
}

const vendorCurrency = (state)=>{
  if(state.purchaseOrder.vendor==null || state.purchaseOrder.vendor.currency==null)return 'CAD';
  return state.purchaseOrder.vendor.currency.code;
}




export default {
  marginFormatted,
  totalWithMargin,
  unitFormatted,
  subTotal,
  total,
  vendorCurrency
};
